(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["action-element-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('action-element-finder')) {
    customElements.define(
      'action-element-finder',
      class ActionElementFinder extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-action-element-search]');
          this.links = Array.from(this.querySelectorAll('[data-action-element-link]'));
          this.count = this.querySelector('[data-action-element-count]');
          this.empty = this.querySelector('[data-action-element-empty]');

          if (!this.input || this.links.length === 0) return;

          this.input.addEventListener('input', () => this.filter());
          this.filter();
        }

        normalize(value) {
          return value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
        }

        filter() {
          const query = this.normalize(this.input.value);
          let visible = 0;

          this.links.forEach((link) => {
            const label = this.normalize(link.dataset.actionElementLabel || link.textContent || '');
            const words = label.split(' ');
            const matches = query === '' || label.startsWith(query) || words.some((word) => word.startsWith(query));
            link.hidden = !matches;
            if (matches) visible += 1;
          });

          if (this.count) {
            this.count.textContent = query === '' ? `${visible} action elements` : `${visible} matches`;
          }

          if (this.empty) {
            this.empty.hidden = visible !== 0;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
